import { BookOpen, Calculator, ListChecks, Puzzle, SpellCheck, WholeWord } from 'lucide-react';

/**
 * Les éléments communs des vues de progression (11/10/2026). Depuis l'épreuve de Musk du 12/10/2026, plus de
 * verdict, d'écart en points ni de barre de la marge du hasard à l'écran.
 */
export const Carte = ({ icone: Icone, titre, aside, children }) => (
  <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div className="px-5 py-4 border-b border-gray-100 flex flex-wrap items-center gap-2">
      {Icone ? <Icone className="w-5 h-5 text-blue-600" /> : null}
      {/* Taille explicite : le conteneur de l'analyse comparative grossit le texte hérité */}
      <h3 className="text-base font-semibold text-gray-800">{titre}</h3>
      {aside ? <span className="ml-auto text-xs text-gray-500">{aside}</span> : null}
    </div>
    {children}
  </div>
);

/**
 * Une couleur et une icône par partie de l'évaluation nationale (la clé de DOMAINES, margeDuHasard.js) : Lexique et
 * Compréhension ne se confondent pas. Partagées par « Élève par élève » et « Résultats par question ».
 */
export const PARTIES = {
  automatismes: { icone: Calculator, pastille: 'bg-sky-50 text-sky-800 ring-sky-200', barre: 'bg-sky-600', cellule: 'bg-sky-50/50' },
  problemes: { icone: Puzzle, pastille: 'bg-indigo-50 text-indigo-800 ring-indigo-200', barre: 'bg-indigo-600', cellule: 'bg-indigo-50/50' },
  lexique: { icone: WholeWord, pastille: 'bg-violet-50 text-violet-800 ring-violet-200', barre: 'bg-violet-600', cellule: 'bg-violet-50/50' },
  competences: { icone: SpellCheck, pastille: 'bg-teal-50 text-teal-800 ring-teal-200', barre: 'bg-teal-600', cellule: 'bg-teal-50/50' },
  comprehension: { icone: BookOpen, pastille: 'bg-amber-50 text-amber-900 ring-amber-200', barre: 'bg-amber-500', cellule: 'bg-amber-50/50' },
};
/** Une partie hors évaluation nationale (type de question inconnu). */
export const PARTIE_NEUTRE = { icone: ListChecks, pastille: 'bg-slate-50 text-slate-700 ring-slate-200', barre: 'bg-slate-500', cellule: '' };

/** Le nom d'une partie dans sa couleur, avec son icône. */
export const Pastille = ({ partie, nom, petite = false }) => {
  const Icone = partie.icone;
  return (
    <span className={`inline-flex max-w-full items-center gap-1.5 rounded-md ring-1 font-semibold ${partie.pastille} ${petite ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm'}`}>
      <Icone className={`shrink-0 ${petite ? 'w-3.5 h-3.5' : 'w-4 h-4'}`} aria-hidden="true" />
      <span className="truncate">{nom}</span>
    </span>
  );
};
